'use strict';

var debounce = require('lodash/debounce');

var leftScrollClass = 'overflowing--left';
var rightScrollClass = 'overflowing--right';

var overflowXElements = $('.blur-overflox-x');
var scrollToCenter = $('.center-active');

/**
 * handle vertical overflow
 * @param  {Object} scrollableElements element
 */
function handleOverflowX(scrollableElements) {
    scrollableElements.each(function (index, scrollableElement) {
        // If more content on the left
        if ($(scrollableElement).scrollLeft() > 0) {
            $(scrollableElement).parent().addClass(leftScrollClass);
        } else {
            $(scrollableElement).parent().removeClass(leftScrollClass);
        }
        // If more content on the right
        if (
            Math.round($(scrollableElement).scrollLeft() + $(scrollableElement).innerWidth()) <
            scrollableElement.scrollWidth
        ) {
            $(scrollableElement).parent().addClass(rightScrollClass);
        } else {
            $(scrollableElement).parent().removeClass(rightScrollClass);
        }
    });
}

/**
 * @param {Array} elements elements
 */
function centerOnActive(elements) {
    elements.each(function (index, scrollableElement) {
        var activeTab = $(scrollableElement).find('.active');
        if (activeTab) {
            $(scrollableElement).scrollLeft(
                $(scrollableElement).scrollLeft() +
                    activeTab.position().left -
                    $(scrollableElement).innerWidth() / 2 +
                    activeTab.innerWidth() / 2
            );
        }
    });
}

centerOnActive(scrollToCenter);
handleOverflowX(overflowXElements);
overflowXElements.on(
    'scroll',
    debounce(function (e) {
        handleOverflowX($(e.target));
    }, 200)
);
$(window).on(
    'resize',
    debounce(function () {
        centerOnActive(scrollToCenter);
        handleOverflowX(overflowXElements);
    }, 500)
);
